/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';

import { PlayerPhoto } from 'common/react/components/PlayerPhoto';
import { useGetImageScale } from '../hooks/use-get-image-scale';
import { PlayerProfileLink } from 'widgets/statspro/js/components/common/PlayerProfileLink';

/**
 * Renders a player's name and their photo.
 *
 * @param {object} props.player The player data object.
 * @param {string} props.reason The reason the player is removed, e.g. 'injury'.
 * @param {string} props.matchTitle The match title, e.g. 'Sydney Swans v GWS GIANTS'.
 * @param {boolean} props.isAFLW Is player AFLW (needed to generate correct player profile URL)
 * @param {string} props.clubId - The player's club/team ID (used to determine if external)
 * @param props.player.player
 * @param props.player.reason
 * @param props.player.matchTitle
 * @param props.player.isAFLW
 * @param props.player.clubId
 * @returns {JSX.Element} The player name and photo.
 */
export const InsOutsPlayer = ({
    player,
    reason,
    matchTitle,
    isAFLW,
    clubId
}) => {
    const imageScale = useGetImageScale();

    return (
        <div className="team-lineups-ins-and-outs__grid-item-wrapper">
            <PlayerProfileLink
                key={player.playerId}
                classes="team-lineups-ins-and-outs__grid-item"
                player={{
                    playerId: player.playerId,
                    firstName: `${player.playerName.givenName}.`,
                    surname: player.playerName.surname
                }}
                isAFLW={isAFLW}
                clubId={clubId}
                trackingInfo={{
                    event: PULSE.app.common.CONSTANTS.TRACKING.EVENTS.SELECT
                        .LINK,
                    component_name: `${matchTitle} (condensed team lineups)`,
                    component_content_type:
                        PULSE.app.common.CONSTANTS.TRACKING.CONTENT_TYPES
                            .LINEUPS
                }}
            >
                <div className="team-lineups-ins-and-outs__player-name-wrapper">
                    <p className="team-lineups-ins-and-outs__player-name">
                        {player.playerName.givenName}{' '}
                        {player.playerName.surname}
                    </p>
                    {reason ? (
                        <p className="team-lineups-ins-and-outs__player-reason">
                            {reason}
                        </p>
                    ) : null}
                </div>
                <div className="team-lineups-ins-and-outs__headshot">
                    <PlayerPhoto
                        photoUrl={player?.photoURL}
                        alt={`${player?.playerName?.givenName} ${player?.playerName?.surname}`}
                        scale={imageScale}
                    />
                </div>
            </PlayerProfileLink>
        </div>
    );
};

InsOutsPlayer.propTypes = {
    player: PropTypes.object.isRequired,
    reason: PropTypes.string,
    matchTitle: PropTypes.string.isRequired,
    isAFLW: PropTypes.bool,
    clubId: PropTypes.string
};
